module.exports = __webpack_public_path__ + "img/download.b10f0bbf.svg";